var map = {
	"./2024-10/Product.vue": [
		9358,
		9358
	],
	"./2024-11/Product.vue": [
		397968,
		97968
	],
	"./2024-12/Product.vue": [
		169718,
		69718
	],
	"./2025-01/Product.vue": [
		895428,
		95428
	],
	"./2025-03/Product.vue": [
		475756,
		75756
	],
	"./2025-04/Product.vue": [
		528727,
		28727
	],
	"./2025-05/Product.vue": [
		580400,
		80400
	],
	"./2025-06/Product.vue": [
		565975,
		65975
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 532776;
module.exports = webpackAsyncContext;